import React from 'react';

const CampaignInput = ({ campaignText, setCampaignText, onGenerate, isLoading, exampleCampaigns = [] }) => {
  const handleExampleClick = (example) => {
    setCampaignText(`${example.brand}: ${example.description}`);
    // Optional: immediately trigger generate if you want, or just wait for button click
  };

  return (
    <div className="hero-section">
      <h1 className="hero-title">
        AI-Powered <span>Influencer</span> Discovery
      </h1>
      <p className="hero-subtitle">
        Find the perfect influencers for your campaign — powered by intelligent matching
      </p>

      <div className="campaign-input-card">
        <div className="input-row">

          <input
            type="text"
            className="campaign-input"
            placeholder="Describe what you want to create..."
            value={campaignText}
            onChange={(e) => setCampaignText(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onGenerate()}
          />
        </div>

        <div className="examples-scroll-section">
          <div className="examples-scroll-container">
            {exampleCampaigns.map((example) => (
              <button
                key={example.id}
                className="example-pill"
                onClick={() => handleExampleClick(example)}
              >
                <span className="pill-brand">{example.brand}:</span>
                <span className="pill-desc">{example.description}</span>
              </button>
            ))}
          </div>
        </div>

        <button
          className="generate-btn"
          onClick={onGenerate}
          disabled={!campaignText.trim() || isLoading}
        >
          {isLoading ? 'Analyzing...' : 'Generate Recommended Influencers'}
          {!isLoading && <span className="btn-arrow">▶</span>}
        </button>
      </div>
    </div>
  );
};

export default CampaignInput;
